<template>
  <div>
    <form  v-on:submit.prevent="handleCreateUser">
      <div>
        <label for="email" class="native-text-input-label">Email</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <MailIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
              v-model="user.email"
              type="text"
              name="email"
              id="email"
              class="native-text-input-icon"
              placeholder="you@gravysolutions.io" />
        </div>
        <div v-if="roles.length > 0" class="mt-2">
          <label for="roles" class="native-select-label">Role</label>
          <select v-model="user.role" class="native-select">
            <option v-for="role in roles" :value="role">{{ role }}</option>
          </select>
        </div>
      </div>
      <div class="mt-3">
        <primary-button @click="handleCreateUser" text="Create User" />
      </div>
    </form>
  </div>
</template>

<script>
import { MailIcon } from '@heroicons/vue/solid'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";

export default {
  name: "UserForm",
  props: ['isEdit', 'userToUpdate'],
  components: {
    PrimaryButton,
    MailIcon
  },
  data() {
    return {
      user: {
        email: '',
        timeZone: 'America/New_York',
        role: 'Contributor'
      }
    }
  },

  methods: {
    async handleCreateUser() {
      if (!this.isEdit) {
        this.$store.dispatch('createUser', this.user)
      } else {
        await this.handleUpdateUser()
      }
    },
    async handleUpdateUser() {
      // console.log('we are in update mode')
    }
  },
  computed: {
    roles() {
      return this.$store.getters.getRoles
    }
  }
}
</script>

<style scoped>

</style>
